import { Box, Button } from '@mui/material';
import React, { useState, useEffect, useCallback } from 'react';
import moment from 'moment';
import ReportIndexMenu from '../../../../components/analytics/ReportIndexMenu';
import ExecutiveReport from '../../../../components/analytics/ExecutiveReport';
import GlobalReport from '../../../../components/analytics/GlobalReport';
import RegionReport from '../../../../components/analytics/RegionReport';
import AnexoReport from '../../../../components/analytics/AnexoReport';
import { getAppointments } from '../../../../services/appointmentService';
import { getAllClientProgramUsers, getClientProgram } from '../../../../services/clientProgramService';
import { getClientLocations } from '../../../../services/clientService';
import { useBoolean } from '../../../../hooks/useBoolean';
import LoadingContainer from '../../../../components/loaders/LoadingContainer';
import AnalyticsHeaderV2 from '../../../../components/analytics/AnalyticsHeaderV2';
import { useSnackbar } from 'notistack';
import { getPatientDataList, getPatients } from '../../../../services/userService';
import { getDateAddTZFormat, getTimetoUserLocalUtcFormat } from '../../../../utils/formatTime';
import { onGetCurrentPeriod, onGetFirstTimeAndFollowUpPatients } from '../analytics_utils';
import { catalogs } from '../../../../utils/catalogs';
import { Workbook } from 'exceljs';
import FileSaver from 'file-saver'

const AnalyticsBusinessPrograSection = ({
    idclient, 
    idclientprogram
}) => {

    const loading = useBoolean()
    const [appointments, setAppointments] = useState([])
    const [patients, setPatients] = useState([])
    const [program_users, setProgramUsers] = useState()
    const [program_users_original, setProgramUsersOriginal] = useState()

    const [locations, setLocations] = useState([])
    const [program, setProgram] = useState()
    const { enqueueSnackbar } = useSnackbar();

    const [period, setPeriod] = useState({
        month:moment().subtract(1, 'month').month(),
        year:moment().year()
    })
    const [global_year, setGlobalYear] = useState(moment().year())

    const [periodv2, setPeriodV2] = useState({
        start_date:moment().subtract(1,'month').startOf('M').format('YYYY-MM-DD'),
        end_date:moment().subtract(1,'month').endOf('M').format('YYYY-MM-DD'),
    })

    const initialize = useCallback(async() => {
        loading.onTrue()
        const selected_year = Number(periodv2.end_date.split("-")[0])
        
        let _program
        try {
            const request = await getClientProgram(idclientprogram)
            console.log(request)
            _program=request
            setProgram(request)
        } catch (error) {
            
        }
        if(!_program){
            loading.onFalse()
            console.log("Return...")
            return
        }

        //console.log("Selected year", selected_year)
        const start_date = getTimetoUserLocalUtcFormat(_program?.start_date)
        const end_date = getTimetoUserLocalUtcFormat(_program?.end_date, true)
        console.log(_program?.start_date)
        console.log(start_date)
        console.log(_program?.end_date)

        console.log(end_date)
        //const start_date = `${_program?.start_date}T06:00:00.000Z`
        //const end_date = `${selected_year+1}-01-01T06:00:00.000Z`


        try {
            const _appointmentdata = await getAppointments({
                limit:10000, offset:0, order:0, order_by:JSON.stringify(["start_date"]),
                filter:JSON.stringify({AND:[
                    //{field:'user_type_id', operator:"=", value:4},
                    {field:'client_id', operator:"=", value:idclient},
                    {field:'start_date', operator:">=",value:start_date},
                    {field:'start_date', operator:"<=",value:end_date}
                ]})
            })

            let _appointments = []
            for (let index = 0; index < _appointmentdata.data.length; index++) {
                let element = _appointmentdata.data[index];
                let _startdate = element.start_date.split(" ").join("T")+".000Z"
                element.start_date = _startdate
                _appointments.push(element)
            }

            

            setAppointments(_appointments)

            const _users = await getPatients(idclient,{offset:0, limit:1500, fields:JSON.stringify(['id_user','patient_type_id', 'patient_segment_type_id','nutritionist_email'])})
            console.log("Usuarios totales", _users)
            console.log(_users)

            const _userprograms = await getAllClientProgramUsers({
                filter:JSON.stringify({AND:[
                    {field:'client_program_id', operator:"=", value:idclientprogram}
                ]})
            })

            let userprogramsdata = []

            for (let i = 0; i < _userprograms.data.length; i++) {
                const element = _userprograms.data[i];
                const userdata = _users.data.find(el => el.id_user === element?.user_id)

                userprogramsdata.push({
                    ...element,
                    ...userdata
                })
                
            }



            console.log("Usuarios de programa finales", userprogramsdata.length)
            setProgramUsersOriginal(userprogramsdata)
            const filterd_userprograms = userprogramsdata.filter(el => el.patient_type_id === 1) // Solo pasar colaboradores
            console.log(userprogramsdata[0])
            const dismissedpatients = userprogramsdata.filter(el => el.patient_type_id !== 1) // Solo pasar colaboradores
            const dismissedpatientsmac_familiares = userprogramsdata.filter(el => el.patient_type_id === 2 && el.user_client_location_id === 1) // Solo pasar colaboradores
            const dismissedpatientsmac = userprogramsdata.filter(el => !el.patient_type_id && el.user_client_location_id === 1) // Solo pasar colaboradores

            console.log("Usuarios de olvidados finales", dismissedpatients.length)
            console.log("Usuarios de olvidados finales familiares MAC", dismissedpatientsmac_familiares.length)
            console.log("Usuarios de olvidados finales sin asignacion de tipo MAC", dismissedpatientsmac.length)


            console.log("Usuarios de programa finales", userprogramsdata.length)
            console.log("Usuarios filtrados de programa finales", filterd_userprograms.length)

            //console.log(_userprograms.data)
            //_userprograms
            //setProgramUsers(filterd_userprograms) Se debe de revisar si aplicamos filtro de colaborador de nuevo
            setProgramUsers(userprogramsdata)

            const _locationdata = await getClientLocations(idclient, {order:0, order_by:JSON.stringify(['name'])})
            //console.log(_locationdata.data)
            setLocations(_locationdata.data)

            /*
            const _patients = await getPatientDataList({limit:10000, offset:0, filter:JSON.stringify({AND:[
                {field:'client_id', operator:"=", value:idclient}
            ]})})
            //console.log(_patients.data)
            setPatients(_patients.data)
            */
        } catch (error) {
            console.log(error)
        }
        loading.onFalse()
        
    },[idclient, idclientprogram, periodv2])

    useEffect(() => {
        const selected_year = Number(periodv2.end_date.split("-")[0])
        setGlobalYear(selected_year)
    },[])

    useEffect(() => {
        initialize()
    },[])

    const onGetExcelData = useCallback((users) => {
        let data2excel = [["Nombre", "Apellido paterno", "Apellido Materno", "Tipo", "Clasificación","Correo", "Sitio","Nutriologo"]]
        for (let i = 0; i < users.length; i++) {
            const {origin} = users[i];
            console.log(origin)

            const typePatient = catalogs.patient_types.find(el => el.value === origin?.patient_type_id)
            const segmentPatient = catalogs.patient_segment_types.find(el => el.value === origin?.patient_segment_type_id)

            data2excel.push([
                origin?.user_first_name,
                origin?.user_fathers_last_name,
                origin?.user_mothers_last_name,
                typePatient?.label ?? "",
                segmentPatient?.label ?? "",
                origin?.user_email,
                origin?.user_client_location,
                origin?.nutritionist_email
            ])
            
        }
        return data2excel
    },[])

    const onDowloadData = useCallback(async() => {
            const validPeriod = onGetCurrentPeriod(periodv2)
            console.log(validPeriod)
            //const {follow_up_users, first_time_users, valid_period_appointments} = onGetFirstTimeAndFollowUpPatients(program_users, appointments, validPeriod)
            const {follow_up_users, first_time_users, valid_period_appointments} = onGetFirstTimeAndFollowUpPatients(program_users_original, appointments, validPeriod)

            let data2excel_first = onGetExcelData(first_time_users)
            let data2excel_follow = onGetExcelData(follow_up_users)

            const workbook = new Workbook();
            const worksheet = workbook.addWorksheet('Primera vez');

            // Extraer encabezado
            const headers = data2excel_first[0];
            const rows = data2excel_first.slice(1);
            console.log(rows)
            
            // Agregar encabezado
            worksheet.addRow(headers);

            // Agregar filas ordenadas
            rows.forEach((row) => {
                worksheet.addRow(row);
            });
                  
            

            const worksheet2 = workbook.addWorksheet('Seguimiento');
            // Extraer encabezado
            const headers2 = data2excel_follow[0];
            const rows2 = data2excel_follow.slice(1);
            console.log(rows2)

            // Agregar encabezado
            worksheet.addRow(headers2);
      
            // Agregar filas ordenadas
            rows2.forEach((row) => {
                worksheet2.addRow(row);
            });

                  
                    
            // Generar archivo
            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });
            FileSaver.saveAs(blob, `reporte_cliente_${periodv2.start_date}_${periodv2.end_date}.xlsx`);


            
    
    
    },[program_users, appointments, periodv2, program_users_original])



    const [view, setView] = useState(null)

    let contentView = null
    if(!view){
        contentView = <ReportIndexMenu onChange={(value) => setView(value)}/>
    }else{
        if(view === 'overview') contentView = <ExecutiveReport 
            idclient={idclient} 
            idclientprogram={idclientprogram} 
            appointments={appointments}
            program_users={program_users}
            locations={locations}
            period={periodv2}
            onReturn={() => setView(null)}
        />
        if(view === 'global') contentView = <GlobalReport 
            idclient={idclient} 
            idclientprogram={idclientprogram} 
            appointments={appointments}
            program_users={program_users}
            locations={locations}
            period={periodv2}
            onReturn={() => setView(null)}
        />
        if(view === 'region') contentView = <RegionReport 
            idclient={idclient} 
            idclientprogram={idclientprogram} 
            period={periodv2}
            appointments={appointments}
            program_users={program_users}
            locations={locations}
            onReturn={() => setView(null)}
        />
        if(view === 'others') contentView = <AnexoReport 
            idclient={idclient} 
            idclientprogram={idclientprogram} 
            period={periodv2}
            appointments={appointments}
            program_users={program_users}
            locations={locations}
            onReturn={() => setView(null)}
        />
    }
   

    return ( 
        <Box>
            {/*<AnalyticsHeader 
                title={'Reporte'}
                period={period}
                onChange={(data) => setPeriod(data)}
            />*/}
            <AnalyticsHeaderV2
                title={'Reporte v2'}
                period={periodv2}
                onChange={(data) => {
                    setPeriodV2(data)
                    const last_year = data.end_date.split("-")[0]
                    if(data.start_date > data.end_date){
                        enqueueSnackbar("La fecha inicial debe ser menor a la fecha final", {variant:'error'})
                        return
                    }
                    console.log("last year", last_year)
                    console.log("global yera", global_year)
                    if(last_year != global_year){
                        console.log("Cambio de año", last_year)
                        setGlobalYear(last_year)
                        
                    }
                }}
            />
            <LoadingContainer loading={loading.value}>
            <Box>
                <Button onClick={onDowloadData}>
                    Descarga de datos
                </Button>
                {contentView}
            </Box>
            </LoadingContainer>
        </Box>
     );
}
 
export default AnalyticsBusinessPrograSection;